import type { FieldError } from "@/generated/core/v1/value_source";
import type { DraftPriority } from "@/plan-logic/questionnaire/draft";

/** Engine field → the editor's field, for goals and home-buying goals alike. */
const FORM_FIELD: Record<string, string> = {
  required_funding: "cost",
  down_payment: "cost",
  house_price: "housePrice",
  next_due_date: "when",
  due_date: "when",
  end_date: "until",
  level: "importance",
};

const PATH = /^(?:financial_priorities|homebuying_priorities)\[([^\]]+)\]\.([a-z_]+)$/;

/**
 * The engine's field errors on priorities (e.g. `homebuying_priorities[<uuid>].down_payment`, "The
 * down payment on a $400,000 home must be at least $20,000 in Canada."), keyed by the editor's path
 * (`priorities.<i>.cost`) so the message shows beside the field, plus the errors that aren't about a
 * listed priority's field (shown in the save's error list).
 */
export function priorityFieldErrors(
  errors: FieldError[],
  priorities: DraftPriority[],
): { byField: Record<string, string>; rest: FieldError[] } {
  const byField: Record<string, string> = {};
  const rest: FieldError[] = [];
  for (const e of errors) {
    const m = PATH.exec(e.path);
    const i = m ? priorities.findIndex((p) => p.uuid === m[1]) : -1;
    const field = m && FORM_FIELD[m[2]];
    if (i < 0 || !field) {
      rest.push(e);
      continue;
    }
    byField[`priorities.${i}.${field}`] ??= e.message;
  }
  return { byField, rest };
}
